import { Injectable, OnDestroy, inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Service root d'édition inline du dictionnaire. Écoute les clics droits sur le document
 * et remonte le DOM jusqu'à un attribut `data-dict-key`, puis pilote `AppDictKeyEdit` via
 * `popoverState`. Rien à importer dans les composants : seul l'attribut compte.
 */
@Injectable({ providedIn: 'root' })
export class DictKeyService implements OnDestroy {
	private document = inject(DOCUMENT);

	popoverState = signal<{ field: string; x: number; y: number } | null>(null);

	private listener = (event: MouseEvent) => {
		const result = this.findDictKey(event.target as HTMLElement);
		if (!result) return;
		event.preventDefault();
		event.stopPropagation();
		this.popoverState.set({ field: result.key, x: event.clientX, y: event.clientY });
	};

	constructor() {
		this.document.addEventListener('contextmenu', this.listener);
	}

	close() {
		this.popoverState.set(null);
	}

	private findDictKey(element: HTMLElement | null): { key: string; element: HTMLElement } | null {
		while (element) {
			const key = element.getAttribute('data-dict-key');
			if (key) return { key, element };
			element = element.parentElement;
		}
		return null;
	}

	ngOnDestroy() {
		this.document.removeEventListener('contextmenu', this.listener);
	}
}
